import request from '@/utils/request'

export const getUerInfoAPi = (data) => {
    return request({
        url: 'Users/byData',
        method: 'post',
        data
    })
}

export const getClickRecordApi = (data) => {
    return request({
        url: 'Summary/statistics',
        method: 'post',
        data
    })
}

export const getOverviewApi = (data) => {
    return request({
        url: 'Summary/attendance',
        method: 'post',
        data
    })
}

export const getPointsRecordApi = (data) => {
    return request({
        url: 'UserPoints/myList',
        method: 'post',
        data
    })
}

export const getUserDeviceListApi = (data) => {
    return request({
        url: 'DeviceListUser/List',
        method: 'post',
        data
    })
}

export const bindMachineApi = (data) => {
    return request({
        url: 'DeviceListUser/save',
        method: 'post',
        data
    })
}

export const newbindMachineApi = (data) => {
    return request({
        url: 'DeviceListUser/newsave',
        method: 'post',
        data
    })
}

export const delBindApi = (data) => {
    return request({
        url: 'DeviceListUser/del',
        method: 'post',
        data
    })
}

export const bindUserApi = (data) => {
    return request({
        url: 'DuiUsers/save',
        method: 'post',
        data
    })
}